import AdultosPromoCarousel from './components/AdultosPromoCarousel/AdultosPromoCarousel';
import CustomHistoryCarousel from './components/CustomHistoryCarousel';
import CustomQuiz from './components/CustomQuiz';
import CustomTabs from './components/CustomTabs/CustomTabs';
import HeroCarousel from './components/HeroCarousel';
import HeroSlide from './components/HeroSlide';
import InfografiaCarousel from './components/InfografiaCarousel';
import KeyValueIcon from './components/KeyValueIcon';
import Marquee from './components/Marquee';

export const customComponents = [
  { key: 'textInitial', component: KeyValueIcon },
  { key: 'textinitial', component: KeyValueIcon },
  { key: 'iconChild', component: KeyValueIcon },
  { key: 'iconAdult', component: KeyValueIcon },
  { key: 'heroSlide', component: HeroSlide },
  { key: 'heroCarousel', component: HeroCarousel },
  { key: 'adultosPromoCarousel', component: AdultosPromoCarousel },
  { key: 'infografiaCarousel', component: InfografiaCarousel },
  { key: 'marquee', component: Marquee },
  { key: 'customTabs', component: CustomTabs },
  { key: 'customQuiz', component: CustomQuiz },
  { key: 'customHistoryCarousel', component: CustomHistoryCarousel },
];
